"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrlDestination = exports.isLandingPageDestination = void 0;
const isLandingPageDestination = (obj) => {
    return obj.type === 'LANDINGPAGE';
};
exports.isLandingPageDestination = isLandingPageDestination;
const isUrlDestination = (obj) => {
    return obj.type === 'URL';
};
exports.isUrlDestination = isUrlDestination;
